module.exports = __webpack_public_path__ + "static/media/ws.d218a365.svg";